import { api } from 'store/api';
import { ApiResponse } from 'store/api/types';

import { EmptyResponse } from 'store/commonTypes';
import { UserDetails } from 'store/signup/models';
import { ThirdPartySSOInfo, User } from './models';
import { LicenseStatus } from 'store/app/enums';
import { Preferences, preferences } from 'utils/preferences';

export interface LoginResponse extends ApiResponse {
  data: { useMFA: boolean; email: string; password: string };
}

export const login = (
  loginParams: UserDetails,
  gCaptchaResponse: string,
  mfaCode: string | null
): Promise<LoginResponse> =>
  api.post<LoginResponse>('/auth/login', {
    body: { user: loginParams, gCaptchaResponse, mfaCode },
  });

export type UserLicenceResponse = {
  blockedFeatures: any[];
  expire_date: string;
  expire_trial: string;
  isInTrial: boolean;
  next_expire_date: string;
  typeId: string;
  status: LicenseStatus | null;
  maxVatCheckers: number;
  maxConnectedEntity: number;
};

export interface UserResponse extends ApiResponse {
  data: {
    subscriptionDetails: UserLicenceResponse;
    user: User;
  };
}

export const getCurrentUser = (): Promise<UserResponse> =>
  api.get<UserResponse>('/auth/account/details');

export const updateCurrentUserPreferences = (
  preferenceId: string,
  preferences: Preferences[]
): Promise<ApiResponse> => {
  const cUrl = preferenceId
    ? `/auth/account/details/save/preferences/${preferenceId}`
    : '/auth/account/details/save/preferences';
  return api.post<ApiResponse>(cUrl, {
    body: {
      jsonPreference: JSON.stringify(preferences),
    },
  });
};

export const logout = (): Promise<EmptyResponse> =>
  api.post<EmptyResponse>('/auth/logout');

export type ResetPasswordRequest = { user: UserDetails; redirectURL: string };
export const resetPasswordEmail = (
  user: UserDetails
): Promise<EmptyResponse> => {
  const redirectURL = `${process.env.PUBLIC_URL}/forgot-password/confirm`;
  const resetPasswordRequest: ResetPasswordRequest = { user, redirectURL };
  return api.put<EmptyResponse>('/common/forgotten/send', {
    body: resetPasswordRequest,
  });
};

export interface GetThirdPartySSOUrlResponse extends ApiResponse {
  data: { ssoRedirectUrl: string };
}
export const getThirdPartySSOUrl = (
  thirdPartySSO: ThirdPartySSOInfo
): Promise<GetThirdPartySSOUrlResponse> => {
  return api.get<GetThirdPartySSOUrlResponse>(
    `/auth/identityProvider/${thirdPartySSO.ssoLoginName}/generateUrl?redirect_uri=${thirdPartySSO.ssoCallbackUrl}`
  );
};
